import { render, staticRenderFns } from "./AutoSuggestion.vue?vue&type=template&id=6c367744&"
import script from "./AutoSuggestion.vue?vue&type=script&lang=js&"
export * from "./AutoSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./AutoSuggestion.vue?vue&type=style&index=0&id=6c367744&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports